// extracted by mini-css-extract-plugin
export default {"card":"Clubs-Trainers-Info_card__XtlwX","scrollContainer":"Clubs-Trainers-Info_scrollContainer__5Lb6q","container":"Clubs-Trainers-Info_container__Wa+Ug"};